{
  "familyId": "TIJD-ANALOOG",
  "questions": [
    {
      "id": "TIJD-ANALOOG-001",
      "familyId": "TIJD-ANALOOG",
      "module": "Tijd",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het op deze klok?",
      "options": ["03:15", "03:45", "03:30", "03:00"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": {"hours": 3, "minutes": 15, "format": "24h"},
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_analog_quarter",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "stimulusAids": [{ "type": "clock", "data": {"hours": 3, "minutes": 15} }],
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "Kwart over aflezen", "content": "De kleine wijzer staat tussen de 3 en de 4, dus het uur is 3. De grote wijzer wijst naar de 3, dat is kwart over (15 minuten). Het antwoord is 03:15." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 3 en de 4, dus het uur is 3. De grote wijzer wijst naar de 3 — tel: 3 × 5 = 15 minuten. Dat is kwart over. Samen is dat 03:15.",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat tussen de 3 en de 4 → het uur is 3",
          "Kijk naar de grote wijzer: die wijst naar de 3 → 3 × 5 = 15 minuten",
          "Kwart over = 15 minuten → het is 03:15"
        ],
        "distractorExplanations": {
          "0": "Goed! De kleine wijzer staat bij de 3 en de grote wijzer bij de 3 (kwart over = 15 minuten). Dat is 03:15.",
          "1": "Je dacht waarschijnlijk dat kwart over en kwart voor hetzelfde zijn. Maar de grote wijzer staat op de 3 (kwart over = 15 minuten), niet op de 9 (kwart voor = 45 minuten). Onthoud: 3 = kwart over, 9 = kwart voor.",
          "2": "Je dacht waarschijnlijk dat de grote wijzer op de 6 staat. Maar de grote wijzer staat op de 3, niet op de 6. De 3 = 15 minuten (kwart over), de 6 = 30 minuten (half). Onthoud: tel altijd de streepjes bij de grote wijzer.",
          "3": "Je dacht waarschijnlijk dat de grote wijzer op de 12 staat. Maar de grote wijzer staat op de 3 (15 minuten), niet op de 12 (0 minuten). Onthoud: als de grote wijzer op de 12 staat = heel uur, op de 3 = kwart over."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-002",
      "familyId": "TIJD-ANALOOG",
      "module": "Tijd",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["07:30", "08:30", "07:00", "08:00"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": {"hours": 7, "minutes": 30, "format": "24h"},
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_analog_half",
      "variantIndex": 2,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.80,
      "stimulusAids": [{ "type": "clock", "data": {"hours": 7, "minutes": 30} }],
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "Half acht aflezen", "content": "De kleine wijzer staat tussen de 7 en de 8. Bij 'half' kijk je naar het volgende uur, maar het is nog niet 8 uur. De grote wijzer staat op de 6 (half). Het antwoord is 07:30 (half acht)." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 7 en de 8, dus het uur is 7. De grote wijzer wijst naar de 6 — dat is 30 minuten (half). Het is 07:30, ook wel 'half acht' genoemd.",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat tussen de 7 en de 8 → het uur is 7",
          "Kijk naar de grote wijzer: die wijst naar de 6 → 30 minuten (half)",
          "Het is 07:30 (half acht)"
        ],
        "distractorExplanations": {
          "0": "Goed! De kleine wijzer staat tussen 7 en 8, en de grote wijzer op de 6 (half). Dat is 07:30.",
          "1": "Je dacht waarschijnlijk dat het uur 8 is. Maar de kleine wijzer staat nog niet bij de 8 — hij zit tussen de 7 en de 8. Bij 'half' schuift de kleine wijzer al richting het volgende uur, maar het is nog 7 uur. Onthoud: zolang de kleine wijzer de 8 niet bereikt heeft, is het uur 7.",
          "2": "Je dacht waarschijnlijk dat de grote wijzer op de 12 staat. Maar de grote wijzer staat op de 6 (30 minuten), niet op de 12 (0 minuten). Onthoud: als de grote wijzer op de 12 staat = heel uur, op de 6 = half.",
          "3": "Je dacht waarschijnlijk dat de kleine wijzer het uur 8 aangeeft en de grote wijzer 0 minuten. Maar de kleine wijzer (kort) staat tussen 7 en 8, de grote wijzer (lang) op de 6. Onthoud: kort = uur, lang = minuten."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-003",
      "familyId": "TIJD-ANALOOG",
      "module": "Tijd",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het op de klok?",
      "options": ["10:45", "10:15", "11:45", "09:45"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": {"hours": 10, "minutes": 45, "format": "24h"},
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_analog_quarter_to",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "stimulusAids": [{ "type": "clock", "data": {"hours": 10, "minutes": 45} }],
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "Kwart voor aflezen", "content": "De kleine wijzer staat tussen de 10 en de 11, dus het uur is 10. De grote wijzer wijst naar de 9, dat is kwart voor (45 minuten). Het antwoord is 10:45 (kwart voor elf)." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 10 en de 11, dus het uur is 10. De grote wijzer wijst naar de 9 — tel: 9 × 5 = 45 minuten. Dat is kwart voor. Het is 10:45, ook wel 'kwart voor elf' genoemd.",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat tussen de 10 en de 11 → het uur is 10",
          "Kijk naar de grote wijzer: die wijst naar de 9 → 9 × 5 = 45 minuten",
          "Kwart voor = 45 minuten → het is 10:45 (kwart voor elf)"
        ],
        "distractorExplanations": {
          "0": "Goed! De kleine wijzer staat bij de 10 en de grote wijzer bij de 9 (kwart voor = 45 minuten). Dat is 10:45.",
          "1": "Je dacht waarschijnlijk dat kwart over en kwart voor hetzelfde zijn. Maar de grote wijzer staat op de 9 (kwart voor = 45 minuten), niet op de 3 (kwart over = 15 minuten). Onthoud: 3 = kwart over, 9 = kwart voor.",
          "2": "Je dacht waarschijnlijk dat het uur 11 is. Maar de kleine wijzer staat nog niet bij de 11 — hij zit tussen de 10 en de 11. Bij 'kwart voor' schuift de kleine wijzer al richting het volgende uur, maar het is nog 10 uur. Onthoud: zolang de kleine wijzer de 11 niet bereikt, is het uur 10.",
          "3": "Je dacht waarschijnlijk dat de kleine wijzer bij de 9 staat. Maar de kleine wijzer staat tussen de 10 en de 11, niet tussen de 9 en de 10. Onthoud: kijk goed waar de korte wijzer precies staat."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-004",
      "familyId": "TIJD-ANALOOG",
      "module": "Tijd",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["02:20", "04:20", "02:40", "04:10"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": {"hours": 2, "minutes": 20, "format": "24h"},
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_analog_minutes",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "stimulusAids": [{ "type": "clock", "data": {"hours": 2, "minutes": 20} }],
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "Minuten tellen", "content": "De kleine wijzer staat tussen de 2 en de 3, dus het uur is 2. De grote wijzer wijst naar de 4. Tel de minuten: elke streep is 5 minuten. 4 × 5 = 20 minuten. Het antwoord is 02:20." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 2 en de 3, dus het uur is 2. De grote wijzer wijst naar de 4 — tel: 4 × 5 = 20 minuten. Het is 02:20.",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat tussen de 2 en de 3 → het uur is 2",
          "Kijk naar de grote wijzer: die wijst naar de 4 → 4 × 5 = 20 minuten",
          "Het is 02:20"
        ],
        "distractorExplanations": {
          "0": "Goed! De kleine wijzer staat bij de 2 en de grote wijzer bij de 4 (20 minuten). Dat is 02:20.",
          "1": "Je dacht waarschijnlijk dat de kleine en grote wijzer omgedraaid zijn. Maar de kleine wijzer (kort) staat bij de 2 (= uur), de grote wijzer (lang) bij de 4 (= minuten). Onthoud: kort = uur, lang = minuten.",
          "2": "Je dacht waarschijnlijk dat de grote wijzer op de 8 staat. Maar de grote wijzer staat op de 4 (20 minuten), niet op de 8 (40 minuten). Onthoud: tel vanaf de 12 met de klok mee: 4 × 5 = 20.",
          "3": "Je dacht waarschijnlijk dat beide wijzers omgedraaid zijn. Maar de kleine wijzer staat bij de 2 (niet 4) en de grote wijzer bij de 4 (niet 2). Onthoud: kort = uur, lang = minuten."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-005",
      "familyId": "TIJD-ANALOOG",
      "module": "Tijd",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het op deze klok?",
      "options": ["12:00", "06:00", "12:30", "00:00"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": {"hours": 12, "minutes": 0, "format": "24h"},
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_analog_twelve",
      "variantIndex": 5,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.82,
      "stimulusAids": [{ "type": "clock", "data": {"hours": 12, "minutes": 0} }],
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "Twaalf uur aflezen", "content": "Beide wijzers staan op de 12. De kleine wijzer wijst naar 12 uur en de grote wijzer naar 0 minuten. Het antwoord is 12:00 (twaalf uur precies)." }
      }],
      "feedback": {
        "explanationText": "Beide wijzers staan op de 12. De kleine wijzer op 12 = 12 uur. De grote wijzer op 12 = 0 minuten. Het is 12:00 (twaalf uur precies).",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat op de 12 → het uur is 12",
          "Kijk naar de grote wijzer: die staat ook op de 12 → 0 minuten",
          "Beide wijzers op de 12 = heel uur → het is 12:00"
        ],
        "distractorExplanations": {
          "0": "Goed! Beide wijzers staan op de 12, dat is 12:00 (twaalf uur precies).",
          "1": "Je dacht waarschijnlijk dat de kleine wijzer op de 6 staat. Maar de kleine wijzer staat op de 12 (bovenaan), niet op de 6 (onderaan). Onthoud: 12 en 6 liggen precies tegenover elkaar op de klok.",
          "2": "Je dacht waarschijnlijk dat de grote wijzer op de 6 staat. Maar de grote wijzer staat op de 12 (0 minuten), niet op de 6 (30 minuten). Onthoud: als beide wijzers op de 12 staan, is het precies een heel uur.",
          "3": "Je dacht waarschijnlijk dat 12:00 en 00:00 hetzelfde zijn. Maar 12:00 is twaalf uur 's middags, en 00:00 is middernacht (begin van een nieuwe dag). Onthoud: op een analoge klok zien beide er hetzelfde uit, maar de context bepaalt welke het is."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-006",
      "familyId": "TIJD-ANALOOG",
      "module": "Tijd",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["05:55", "06:55", "05:50", "06:00"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": {"hours": 5, "minutes": 55, "format": "24h"},
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_analog_five_to",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "stimulusAids": [{ "type": "clock", "data": {"hours": 5, "minutes": 55} }],
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "Vijf voor aflezen", "content": "De kleine wijzer staat bijna bij de 6, maar nog niet helemaal. Het uur is dus 5. De grote wijzer wijst naar de 11, dat is 55 minuten (5 voor 6). Het antwoord is 05:55." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat bijna bij de 6, maar nog niet helemaal — het uur is dus 5. De grote wijzer wijst naar de 11 — tel: 11 × 5 = 55 minuten. Het is 05:55 (vijf voor zes).",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat bijna bij de 6, maar nog niet helemaal → het uur is 5",
          "Kijk naar de grote wijzer: die wijst naar de 11 → 11 × 5 = 55 minuten",
          "Het is 05:55 (vijf voor zes)"
        ],
        "distractorExplanations": {
          "0": "Goed! De kleine wijzer staat nog bij de 5 en de grote wijzer bij de 11 (55 minuten). Dat is 05:55.",
          "1": "Je dacht waarschijnlijk dat het uur 6 is. Maar de kleine wijzer staat bijna bij de 6, maar nog niet helemaal. Onthoud: zolang de kleine wijzer de 6 niet bereikt heeft, is het uur nog 5.",
          "2": "Je dacht waarschijnlijk dat de grote wijzer op de 10 staat. Maar de grote wijzer staat op de 11, niet op de 10. Onthoud: tel nauwkeurig: 11 × 5 = 55 minuten, niet 10 × 5 = 50 minuten.",
          "3": "Je dacht waarschijnlijk dat de grote wijzer op de 12 staat. Maar de grote wijzer staat op de 11 (55 minuten), niet op de 12 (0 minuten). Onthoud: het is bijna 6 uur, maar er ontbreken nog 5 minuten."
        }
      }
    }
  ]
}